<ul>
    <li *ngFor="let threshold of thresholds" [ngClass]="itemClass(threshold)" (click)="click(threshold)"></li>
</ul>
